<template>
  <div class="count-total">
    <div>{{total}}个查询结果</div>
    <slot name="btn"></slot>
  </div>
</template>

<script>
export default {
  name: 'count-total',

  props: ['total']
}
</script>

<style scoped lang="less">
.count-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  margin: 0px 0px;
  div {
    height: 32px;
    display: flex;
    align-items: center;
  }
  button {
    margin-right: -15px;
  }
}
</style>
